import React from "react";
const KS2Footer = () => {
  return (
    <React.Fragment>
       <div className="row">
          <div className="container">
            <div className=" ks10-whitebgbox">
              <div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-6 fontsize-16">
                    <h4 className="">
                      <strong>This form is to provide your details to your employer if you are: </strong>
                    </h4>
                    <ul className="pl-3 mb-1">
                      <li className="pl-2">starting new employment </li>
                      <li className="pl-2">an existing employee and want to opt into KiwiSaver </li>
                      <li className="pl-2">a KiwiSaver member and want to change your contribution rate </li>
                    </ul>

                    <div className="clr" />
                    <h4 className="mt-3">
                      <strong>Starting new employment :</strong>
                    </h4>

                    <p className="mt-3 mb-1">
                      If you’re not already a KiwiSaver member, you will be automatically enrolled if you’re between the ages of 18 and 65 and your employer will begin making KiwiSaver deductions from your first payment of salary or wages. However,
                      you can opt out at any time on or after day 14 and on or before day 56 of starting new employment - see your KiwiSaver information pack for details
                    </p>

                    <div className="clr" />

                    <h4 className="pt-3">
                      <strong>Joining KiwiSaver if you’re a new employee 65 or over</strong>
                    </h4>
                    <p className="mb-2">
                      You can enrol in KiwiSaver by completing this form and giving it to your employer. Your employer will determine if you are eligible and then send your information to Inland Revenue and start making KiwiSaver deductions for you{" "}
                    </p>

                    <p className="mt-3">
                      <strong>Note:</strong> : If you opt in, you cannot opt out. We suggest you get financial advice before deciding to opt into KiwiSaver
                    </p>

                    <h4 className="pt-3">
                      <strong>Existing employees who want to become KiwiSaver members</strong>
                    </h4>
                    <p className="mb-2">
                      You can enrol in KiwiSaver by completing this form and giving it to your employer. Your employer will determine if you are eligible and then send your information to Inland Revenue and start making KiwiSaver deductions for you.
                    </p>
                    <p className="mt-3">
                      <strong>Note:</strong> : If you opt in, you cannot opt out. We suggest you get financial advice before deciding to opt into KiwiSaver.
                    </p>
                    <div className="clr" />
                    <h4 className="pt-3">
                      <strong>Joining KiwiSaver if you’re under 18</strong>
                    </h4>
                    <p className="mb-2">If you’re under 18 you can only join KiwiSaver by contacting your chosen scheme provider directly. You cannot join through your employer</p>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-6 fontsize-16">
                    <h4 className="pt-3">
                      <strong>Existing KiwiSaver member</strong>
                    </h4>
                    <p className="mb-1">
                      If you are already a member, your employer should begin making KiwiSaver deductions for you unless you show them a savings suspension notice. To ensure deductions start it is recommended that you provide a KS2 form to your new
                      employer and to request confirmation the form has been received. You’ll find more information in your KiwiSaver information pack or go to{" "}
                      <a href="https://www.ird.govt.nz/kiwisaver" target="_blank">
                        <strong> ird.govt.nz/kiwisaver</strong>
                      </a>
                    </p>
                    <h4 className="pt-3">
                      <strong>Contribution rate</strong>
                    </h4>
                    <p>
                      KiwiSaver contributions will be deducted from each payment of your salary or wages. You may choose a contribution rate of 3%, 4%, 6%, 8% or 10%. If you don’t choose a rate, the default rate of 3% applies. If you want to
                      contribute more you can make voluntary contributions directly to your scheme provider.
                    </p>
                    <p>If you want to change your contribution rate, complete sections B and C of this form and give it to your employer.</p>
                    <p>
                      For information on total remuneration packages and good faith bargaining refer to{" "}
                      <a href="https://www.ird.govt.nz/kiwisaver" target="_blank">
                        <strong> ird.govt.nz/kiwisaver </strong>
                      </a>
                      and
                      <a href="https://www.employment.govt.nz" target="_blank">
                        <strong>employment.govt.nz</strong>
                      </a>
                    </p>

                    <h4 className="pt-3">
                      <strong>Privacy</strong>
                    </h4>
                    <p>
                      Find our full privacy policy at
                      <a href="https://www.ird.govt.nz/privacy" target="_blank">
                        <strong>ird.govt.nz/privacy</strong>
                      </a>{" "}
                      to register.
                    </p>
                    <p className="mb-1">
                      <strong>What an employer should do with this completed form</strong>
                    </p>
                    <p className="mb-0">
                      <strong>Employer -</strong> don’t send this form to Inland Revenue. If the new employee is subject to automatic enrolment or an existing employee opts in, use this information to assist you to complete the IR346K. Keep this form
                      with your business records for seven years following the last salary or wage payment you make to the employee.
                    </p>
                    <div className="clr" />
                    <br />
                    <p>
                      For more information about KiwiSaver go to{" "}
                      <a href="https://www.ird.govt.nz/kiwisaver" target="_blank">
                        <strong>ird.govt.nz/kiwisaver</strong>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              {/* <!--Information end--> */}
            </div>
          </div>
        </div>
    </React.Fragment>
  )
}

export default KS2Footer;